import React, {Component} from 'react';
import {
    // FormControl,
    PanelContainer,
    Panel,
    PanelHeader,
    PanelBody
} from '@sketchpixy/rubix'


class MuscleStrengthScale extends Component {
    constructor(props) {
        super(props)
        
        this.state = {
            rules : props.rules
        }
        
    }
    componentDidMount() {
      }
      componentWillUnmount() {
        
      }
    render() {
        let { rules } = this.state;
        const {
            onClose
          } = this.props

        const pillsColors = ['#092433', '#023855', '#005A8C', '#0072B0', '#008DDB', '#02A4FF']

        return (
            <div className="overlay-msg " onClick={e => {onClose(e)}}> 
                {/* <div className="animate__animated animate__fadeInDown"> */}
                <div className="">
                    {rules.map((question, i) => 
                        
                        <div key={"selectFieldfirstDiv"+i}>
                            <PanelContainer containerClasses="rubix-panel-container-with-bottom-shadow">
                                <Panel>
                                    <PanelHeader className="row">            
                                            <div className='rms-legend-heading'>{question.label}</div>                                             
                                    </PanelHeader>
                                    <PanelBody className="selectbox-body">
                                        <PanelContainer >
                                            <Panel>
                                                <PanelBody className="selectbox-bodyinner">
                                                    <div className="row select-question-padding-left" >
                                                    {question.options.map((optn, index) => <div key={"selectFieldDiv"+index}  className={optn.values ? "col-md-12 selectbox-single": "col-md-12 mp-0 text-left"} >
                                                        
                                                        <label  className="col-sm-10 selectbox-label mp-0">{optn.main}</label>
                                                        
                                                        <div className="col-sm-2 muscle-strength-rate rules-pill" style={{backgroundColor : pillsColors[optn.sub[0]]}}>
                                                            {optn.sub}
                                                        </div>

                                                    </div>)}
                                                    </div>
                                                </PanelBody>
                                            </Panel>
                                        </PanelContainer>
                                    </PanelBody>
                                </Panel>
                            </PanelContainer>
                        </div>                        
                    )}
                </div>
            </div>
        );
    }
}

export default MuscleStrengthScale